import React from 'react';
import ProgramFlow from './ProgramFlow';
import './HowItWorks.css';

function HowItWorks() {
  return (
    <section className="aqp-section aqp-hiw" data-screen-label="How it runs">
      <div className="aqp-hiw__inner">
        <div className="aqp-reveal aqp-hiw__head">
          <span className="aqp-eyebrow">The whole program, running</span>
          <h2 className="aqp-hiw__h2">How It <span>Works.</span></h2>
        </div>

        <div className="aqp-reveal aqp-fit aqp-hiw__fit" data-fit="1240">
          <div className="aqp-fit__scale" data-fit-scale="" style={{ width: 1240 }}>
            <ProgramFlow />
          </div>
        </div>

        <div className="aqp-fit__hint" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 7l-4 5 4 5M16 7l4 5-4 5M4 12h16" />
          </svg>
          Scroll to explore the full diagram
        </div>

        <p className="aqp-reveal aqp-hiw__caption">
          Work flows in from every source on your project. Our AI quality team reviews it, flags anything
          that looks wrong back to the field, and saves the verified record. The signals you care about run
          straight to you.
        </p>
      </div>
    </section>
  );
}

export default HowItWorks;
